import React from 'react';

import Button, { ButtonProps } from './button';

const ButtonWithRef = React.forwardRef((props: ButtonProps, ref) => (
  <Button
    buttonType="secondary"
    {...props}
    overrides={{
      Root: {
        props: {
          ref,
        },
      },
    }}
  />
));

ButtonWithRef.displayName = 'ButtonWithRef';

export default ButtonWithRef;
